import { checkCellValueStyle } from '@toggle/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useGetV2ThemePerformance } from '~/react-query-hooks/themes/useGetV2ThemePerformance';
import { formatNumber } from '~/views/dashboard/calendar-widget/calendar-event-drawer/drawer-content/utils/number-formatter';

import * as S from './RevampOneDayReturnPill.styles';

export const RevampOneDayReturnPill = ({ themeId }: { themeId: string }) => {
  const { t } = useTranslation('widget');

  const { data } = useGetV2ThemePerformance({
    ids: themeId,
    intraday: true,
  });

  const value = data?.themes?.[0]?.intraday?.current;
  const numericalStyle = checkCellValueStyle(value);

  if (value === undefined) {
    return null;
  }

  return (
    <S.RightHeaderWrapper $numericalStyle={numericalStyle}>
      <S.RightHeaderReturnValue $numericalStyle={numericalStyle}>
        {formatNumber({ isPercentage: false, value })}
      </S.RightHeaderReturnValue>
      <S.RightHeaderReturnLabel>
        {t('widget:themeOverview.lastClose')}
      </S.RightHeaderReturnLabel>
    </S.RightHeaderWrapper>
  );
};
